import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { IOrdersProductDetails } from '../../components/order-summary/OrderSummary';
import { MarginType } from './margin';
import MarginComponent from '../../components/customComponents/MarginComponent';
import PaddingComponent from '../../components/customComponents/PaddingComponent';
import { PaddingType } from './padding';
import { FieldLabel } from '@measured/puck';
import CustomTooltip from '../../../components/common/tooltip';
import CustomizePanel from '../../components/order-summary/customize-props';

interface OrderSummaryCartProps {
  value: IOrdersProductDetails;
  onChange: (_value: IOrdersProductDetails) => void;
  title: string;
  showComponent?: boolean;
  showHover?: boolean;
}

const OrderSummaryCart: React.FC<OrderSummaryCartProps> = ({
  value,
  onChange,
  title,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      <div
        className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
        onClick={() => setIsOpen(!isOpen)}>
        <h3>{title}</h3>
        {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      </div>
      {isOpen && (
        <div className="flex flex-col gap-4 mt-3  border border-gray-300 rounded p-2 w-full">
          <CustomizePanel
            title="Product Name"
            value={value.productName}
            onChange={values => {
              onChange({ ...value, productName: values });
            }}
            showPlaceholderInput={false}
          />
          <CustomizePanel
            title="Product Price"
            value={value.productPrice}
            onChange={values => {
              onChange({ ...value, productPrice: values });
            }}
            showPlaceholderInput={false}
          />
          <CustomizePanel
            title="Product Quantity"
            value={value.productQuantity}
            onChange={values => {
              onChange({ ...value, productQuantity: values });
            }}
            showPlaceholderInput={false}
          />
          <MarginComponent
            value={value.margin}
            onChange={(values: MarginType) => {
              onChange({ ...value, margin: values });
            }}
          />
          <PaddingComponent
            value={value.padding}
            onChange={(values: PaddingType) => {
              onChange({ ...value, padding: values });
            }}
          />
          <FieldLabel
            label={
              (
                <CustomTooltip title="device">
                  <span>Device</span>
                </CustomTooltip>
              ) as React.ReactNode as string
            }>
            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                className="!appearance-auto"
                checked={value?.showOnDesktop}
                onChange={e =>
                  onChange({
                    ...value,
                    showOnDesktop: e.target.checked,
                  })
                }
              />
              <label>Show on desktop</label>
            </div>
            <div className="flex items-center space-x-2 mt-2">
              <input
                type="checkbox"
                className="!appearance-auto"
                checked={value?.showOnTablet}
                onChange={e =>
                  onChange({
                    ...value,
                    showOnTablet: e.target.checked,
                  })
                }
              />
              <label>Show on tablet</label>
            </div>
            <div className="flex items-center space-x-2 mt-2">
              <input
                type="checkbox"
                className="!appearance-auto"
                checked={value?.showOnMobile}
                onChange={e =>
                  onChange({
                    ...value,
                    showOnMobile: e.target.checked,
                  })
                }
              />
              <label>Show on mobile</label>
            </div>
          </FieldLabel>
        </div>
      )}
    </div>
  );
};

export default OrderSummaryCart;
